import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading text-primary-500 whitespace-nowrap cursor-pointer">
              牛牛影视
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              聚合海量电影、电视剧、综艺节目，每日更新最新影视资源，一站式满足追剧观影需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              影视分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              热门推荐
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/article/12" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  哪吒之魔童闹海
                </Link>
              </li>
              <li>
                <Link to="/article/14" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  庆余年 第二季
                </Link>
              </li>
              <li>
                <Link to="/article/1" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  流浪地球3
                </Link>
              </li>
              <li>
                <Link to="/article/5" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  狂飙
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2020-2026 牛牛影视 版权所有 | 本站内容仅供学习交流
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}